import Papa, { ParseResult } from "papaparse";
import * as constants from "../store/Constants";
import { Recipe } from "../store/Recipe";
import { setLocalStorage } from "./LocalStorageHelpers";

export enum SyncState {
  IN_PROGRES,
  COMPLETE,
}

// https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
export function isValidHttpUrl(maybeUrl: string) {
  let url;

  try {
    url = new URL(maybeUrl);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export type GetRecipeIndexInterface = {
  url: string;
  setData: (data: Recipe[]) => void;
  setStatus: (state: SyncState) => void;
};

export const getRecipeIndex = (props: GetRecipeIndexInterface) => {
  console.log("Download triggered...");
  props.setStatus(SyncState.IN_PROGRES);
  // Papa parse does a XMLHttpRequest
  // And returns a "parse result" object
  // We should pull out the data in our desired format
  // and return it to Main as state. :)

  // Input validation part 1.
  if (!isValidHttpUrl(props.url)) {
    console.log("Invalid url:", props.url);
    return;
  }

  Papa.parse(props.url, {
    download: true,
    header: true, // uses similar format to pandas to_json records, each index will be a json object
    dynamicTyping: true, // turn on for time
    complete: function (results: ParseResult<Record<string, unknown>>) {
      console.log("Parsing complete:", results);

      // Input validation part 2.
      if (results.data.length > 0) {
        if (results.data[0]["Name"] !== undefined) {
          console.log("Name found. Likely good data set.");
        } else {
          console.log("Name not found. Exiting.");
          return;
        }
      } else {
        console.log("Data unavailable. Exiting.");
        return;
      }

      // Run a basic filter.
      // If every single line is empty, don't use that line.
      // Also a recipe should at LEAST have a name.
      const dataArrayBasicFilter = results.data.filter(
        (record) =>
          !Object.values(record).every((x) => x === null || x === "") &&
          record[constants.Name]
      );

      const dataArray = dataArrayBasicFilter.map((record) => {
        return {
          [constants.EntryDate]: record[constants.EntryDate],
          [constants.Name]: record[constants.Name],
          [constants.Category]: record[constants.Category],
          [constants.Cuisine]: record[constants.Cuisine],
          [constants.Form]: record[constants.Form],
          [constants.Time]: record[constants.Time],
          [constants.Method]: record[constants.Method],
          [constants.Vegetarian]: record[constants.Vegetarian],
          [constants.Ingredients]: record[constants.Ingredients],
          [constants.Notes]: record[constants.Notes],
          [constants.Link]: record[constants.Link],
          [constants.Image]: record[constants.Image],
          [constants.Lists]: record[constants.Lists],
        } as Recipe;
      });

      console.log(dataArray);
      setLocalStorage({ index: dataArray, url: props.url, date: new Date() });
      props.setData(dataArray);
      props.setStatus(SyncState.COMPLETE);
    },
  });

  console.log(
    "I love you Maya! I love you Alex. :) Thank you both so much for contributing to this project with me."
  );
};
